/**
 * 人民币中间价页面
 */

 import React from "react"
 import ReactDOM from "react-dom"
 import { Page_CNY } from "../components/page/cnyrate";
 
 if(window.quotedata){
   ReactDOM.render(
     <Page_CNY quotedata={window.quotedata}/>,
     document.getElementById('app')
   )  
 }
 
 